"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _reactTopLoadingBar = _interopRequireDefault(require("react-top-loading-bar"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _UiContext = _interopRequireDefault(require("../../context/UiContext"));
var _PageTransition = _interopRequireDefault(require("./PageTransition.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PageTransition = _ref => {
  var _theme$palette;
  let {
    children,
    color,
    disableTransition = false,
    offset = 0,
    position = "top",
    showLoadingBar = true,
    LoadingBarProps
  } = _ref;
  const [loading, setLoading] = (0, _react.useState)(false);
  const [ui] = (0, _react.useContext)(_UiContext.default);
  const {
    _loading = false
  } = ui || {};
  const location = (0, _reactRouterDom.useLocation)();
  const {
    hash,
    pathname
  } = location;
  const loaderRef = (0, _react.useRef)(null);
  const startTimer = (0, _react.useRef)(null);
  const theme = (0, _useTheme.default)();
  const css = (0, _PageTransition.default)();
  (0, _react.useEffect)(() => {
    if (showLoadingBar && loaderRef !== null && loaderRef !== void 0 && loaderRef.current) loaderRef.current.continuousStart();
    startTimer.current = new Date();
    setLoading(true);
    if (hash) {
      const elementToScroll = document.getElementById(hash === null || hash === void 0 ? void 0 : hash.replace("#", ""));
      if (elementToScroll) {
        setTimeout(() => {
          window.scrollTo({
            top: elementToScroll.offsetTop - offset,
            behavior: "smooth"
          });
        }, 100);
        return;
      }
    } else {
      window.scrollTo({
        top: 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, offset]);
  (0, _react.useEffect)(() => {
    let timeout = null;
    if (!_loading) {
      const differenceToOneSecond = 300 - (new Date().getTime() - startTimer.current.getTime());
      const timer = differenceToOneSecond > 0 ? differenceToOneSecond : 0;
      timeout = setTimeout(() => {
        if (showLoadingBar && loaderRef !== null && loaderRef !== void 0 && loaderRef.current) loaderRef.current.complete();
        setLoading(false);
      }, timer);
    }
    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_loading, showLoadingBar]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: pathname
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)({
      [css.hide]: !disableTransition && loading
    })
  }, children), showLoadingBar && /*#__PURE__*/_react.default.createElement(_reactTopLoadingBar.default, _extends({
    color: color ? color : (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.secondary) === null || _theme$palette === void 0 ? void 0 : _theme$palette.main,
    containerClassName: (0, _clsx.default)({
      [css.positionBottom]: position === "bottom"
    }),
    height: 5,
    ref: loaderRef,
    shadow: false
  }, LoadingBarProps)));
};
PageTransition.propTypes = {
  color: _propTypes.default.string,
  disableTransition: _propTypes.default.bool,
  offset: _propTypes.default.number,
  position: _propTypes.default.oneOf(["bottom", "top"]),
  showLoadingBar: _propTypes.default.bool,
  LoadingBarProps: _propTypes.default.object
};
var _default = exports.default = PageTransition;